import notificationSchema from './notification-schema.graphql';


export { notificationSchema };
